import { render, staticRenderFns } from "./modify-information-drawer.vue?vue&type=template&id=33eb555d&scoped=true"
import script from "./modify-information-drawer.vue?vue&type=script&lang=js"
export * from "./modify-information-drawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33eb555d",
  null
  
)

export default component.exports